
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import ShowMoreText from "react-show-more-text";
import { isBrowser } from 'react-device-detect';
import { Helmet } from "react-helmet";


const ProductBrand = () => {

    //#region Const 
    const toaster = rsuite.useToaster();
    const [ProductBrandList, setProductBrandList] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(false);
    const [background, setbackground] = React.useState("../assets/Images/BrandBanner.jpg");

    const handleLoad = () => {
        setLoading(false);
    };

    const handleError = (e) => {
        console.dir(e)
        setLoading(false);
        setError(true);
    };


    const GetProductBrand = () => {
        fetch(General.ApiRoute() + '/ProductBrand/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
                'WebIsActive': 1,
                'IsActive': -1
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                var tmp = []
                for (var i = 0; i < result.length; i++) {
                    tmp.push({
                        id: result[i].id,
                        title: result[i].title,
                        PhotoUrl: General.ApiPhotoRoute() + 'Content/Images/BrandPhoto/' + result[i].id + '.jpg',


                    })
                }

                setProductBrandList(tmp)
            })
    }



    //#endregion
    React.useEffect(() => {
        GetProductBrand();
        localStorage.removeItem("ByBrand");
        localStorage.removeItem("ProductId");

        document.title = "برند محصولات ";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className={isBrowser ? 'InnerBanner' : "InnerBanner_MobView"}
                // className={styles.article}
                style={{ backgroundImage: `url(${background})` }}
            >
            </div>
            <h1 className={isBrowser ? "InnerBanner-text " : "InnerBanner-text_MobView"}>برند محصولات
                <div className={isBrowser ? "InnerBanner-sub-title" : 'hide'}>Product Brand </div>
            </h1>
            <h1 className="ProductInfoAddressBar ">
                <rsuite.Breadcrumb>
                    <rsuite.Breadcrumb.Item href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>

                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682' }}>برند محصولات</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>
            </h1>
            <rsuite.Grid className="pt-3">



                <rsuite.Row className="justify-content-center align-items-center pt-5">

                    {ProductBrandList.map((brand) =>

                        <rsuite.Col xs={12} sm={12} md={6} lg={6} className="pb-4">
                            <rsuite.Panel className='shadow-sm  Selective' bodyFill style={{ display: 'inline-block', width: "100%" }}>


                                <rsuite.Image
                                    src={brand.PhotoUrl}
                                    fallbackSrc="../../assets/images/BrandLogoPrefer.jpg"
                                    alt={brand.title}
                                    placeholder={<img src="../../assets/images/Bars@1x-1.0s-200px-200px.gif" style={{ width: '100%', height: '130px' }} />}
                                    zoomed

                                    style={{  width: '100%', height: '130px' }}
                                />

                                <rsuite.Panel >
                                    <p className="text-truncate Font13 fw-bold text-start" >
                                        {brand.title}
                                    </p>
                                
                                </rsuite.Panel>
                            </rsuite.Panel>

                        </rsuite.Col>
                    )}
                </rsuite.Row>
            </rsuite.Grid>


        </Layout >
    )
}

export default ProductBrand;